<template>
    <v-dialog
        :value="showItemDialog"
        max-width="335"
        @input="deSelectMenuItem"
        scrollable
        transition="scale-transition"
    >
        <v-card :ripple="false" @click="validate">
            <v-card-title class="justify-center primary white--text">{{ selectedItem.title }}</v-card-title>
            <v-divider />
            <v-card-text class="pb-1">
                <v-form
                    ref="form"
                    v-model="valid"
                >
                    <v-container style="width: 200px;">
                        <v-row
                            v-for="({label, items, id}, index) in selectedItem.options"
                            :key="index"
                            align="center"
                            justify="center"
                        >
                            <v-col
                                cols="12"
                                class="px-0 text-center"
                                :class="{'pb-0': items.length > 2}"
                            >
                                <v-btn-toggle
                                    color="primary"
                                    v-if="items.length < 3"
                                    :value="selectedOptions[id]"
                                    @change="optionChanged(id, $event)"
                                    :mandatory="!!selectedOption[id]"
                                    style="min-width: 100%;"
                                >
                                    <v-btn
                                        v-for="({label, id}) in items"
                                        :key="id"
                                        :ripple="false"
                                        :value="id"
                                        active-class="primary white--text"
                                        class="black--text flex-grow-1"
                                    >
                                        {{ label }}
                                    </v-btn>
                                </v-btn-toggle>
                                <v-select
                                    v-else
                                    outlined
                                    :label="`Select ${label}*`"
                                    :value="selectedOptions[id]"
                                    :placeholder="`Select ${label}`"
                                    class="pt-2"
                                    :menu-props="{ contentClass: 'option-select', nudgeTop: 10}"
                                    @change="optionChanged(id, $event)"
                                    :rules="optionRules(label)"
                                    :items="items"
                                    item-text="label"
                                    item-value="id"
                                    required
                                    ref="optionSelect"
                                />
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                            <v-col cols="3" class="px-0 text-center">
                                <v-btn icon @click="populateQuantity--" :disabled="populateQuantity === 1">
                                    <v-icon color="primary">
                                        mdi-minus-circle-outline
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="3" class="text-h5 black--text px-0 text-center">
                                {{ populateQuantity }}
                            </v-col>
                            <v-col cols="3" class="px-0 text-center">
                                <v-btn icon @click="populateQuantity++">
                                    <v-icon color="primary">
                                        mdi-plus-circle-outline
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions ref="cardActions">
                <v-btn
                    color="primary"
                    text
                    v-if="selectedItem.basketIndex !== undefined"
                    @click="removeBasketItem(selectedItem.basketIndex)"
                >Remove</v-btn>
                <v-spacer v-if="selectedItem.basketIndex !== undefined" />
                <v-btn
                    color="primary"
                    depressed
                    :width="selectedItem.basketIndex === undefined ? '100%' : ''"
                    @click="addItem"
                    :disabled="!valid"
                >
                    {{ selectedItem.basketIndex === undefined ? 'Add' : 'Update' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

export default {
  name: 'DialogSelectItem',

  data: () => ({
    valid: true,
  }),

  computed: {
    ...mapState({
      selectedItem: (state) => state.menu.selectedItem,
      showItemDialog: (state) => state.menu.showItemDialog,
    }),

    ...mapGetters([
      'selectedOption',
      'selectedOptions',
    ]),

    populateQuantity: {
      get() {
        return this.$store.state.menu.selectedItem.populateQuantity;
      },
      set(value) {
        this.$store.commit(types.MENU_UPDATE_SELECTED_ITEM_QUANTITY, value);
      },
    },

    navShowItemDialog() {
      return this.$route.meta.showItemDialog;
    },
  },

  watch: {
    async showItemDialog(newValue) {
      if (newValue) {
        await this.$nextTick();
        if (this.$refs.optionSelect && this.$refs.optionSelect.length) {
          this.$refs.optionSelect[0].focus();
        }

        this.$refs.form.resetValidation();
        const route = typeof this.selectedItem.basketIndex !== 'undefined' ? 'basket-select-item' : 'select-item';
        await this.$router.push({ name: route });
      } else if (this.navShowItemDialog) {
        await this.$router.back();
      }
    },

    navShowItemDialog(newValue) {
      if (!newValue) {
        this.deSelectMenuItem();
      }
    },
  },

  methods: {
    optionRules(name) {
      return [
        (v) => !!v || `${name} is required`,
      ];
    },

    optionChanged(id, event) {
      this.selectOption({
        id,
        option: event,
      });
    },

    addItem() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        return;
      }

      const item = {
        id: this.selectedItem.id,
        quantity: this.selectedItem.populateQuantity,
        options: this.selectedOptions,
      };

      this.addBasketItem({ item, index: this.selectedItem.basketIndex });
    },

    validate(e) {
      if (this.valid) {
        return;
      }

      if (Object.is(this.$refs.cardActions, e.target)) {
        this.$refs.form.resetValidation();
        setTimeout(() => {
          this.$refs.form.validate();
        }, 100);
      }
    },

    ...mapActions([
      'addBasketItem',
      'removeBasketItem',
      'deSelectMenuItem',
      'selectOption',
    ]),
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field__details {
    margin-bottom: 0 !important;
  }

  .v-card--link:focus::before {
    opacity: 0 !important;
  }
}
</style>
